import { render, staticRenderFns } from "./BnTarifaDokumentumok.vue?vue&type=template&id=073a61e0&"
import script from "./BnTarifaDokumentumok.vue?vue&type=script&lang=js&"
export * from "./BnTarifaDokumentumok.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports